import store from '../store/store';
import { action, select } from 'satcheljs/lib/legacy';
export default select({
    optionState: function () { return store; },
})(action('discardMessagePreviewOption')(function discardMessagePreviewOption(state) {
    var optionState = state.optionState;
    optionState.showPreviewTextInListView = null;
}));
//# sourceMappingURL=discardMessagePreviewOption.js.map